export function decodeHtmlEntities(text: string): string {
  if (typeof document === 'undefined') return text;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

export { urlSanitize } from '@/lib/utils';

export function groupBy<T>(
  array: T[],
  keyFn: (item: T) => string | number,
): Record<string | number, T[]> {
  return array.reduce(
    (result, item) => {
      const key = keyFn(item);
      if (!result[key]) result[key] = [];
      result[key].push(item);
      return result;
    },
    {} as Record<string | number, T[]>,
  );
}

/**
 * Pure computation of whether the items page is active and whether
 * the router is mid-transition away from it. Used to guard effects
 * that should not fire during pending route transitions.
 */
export function computeTransitionState(
  resolvedPathname: string,
  locationPathname: string,
): { isOnItemsPage: boolean; isTransitioningAway: boolean } {
  const isOnItemsPage = resolvedPathname === '/items' || resolvedPathname === '/items/';
  const isTransitioningAway = isOnItemsPage && !locationPathname.startsWith('/items');
  return { isOnItemsPage, isTransitioningAway };
}
